import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";

const PrivacyPage = () => {
  const hero = (
    <PageHero
      eyebrow="Yasal"
      title="Gizlilik Politikası"
      subtitle="Verasist olarak kişisel verilerinizin korunmasına büyük önem veriyoruz. Bu politika, verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar."
    />
  );

  const Content = ({ children }) => (
    <section className="py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="space-y-10 text-[14.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.88 }}>
          {children}
        </div>
      </div>
    </section>
  );

  const H2 = ({ children }) => <h2 className="text-[20px] font-bold" style={{ color: "var(--fg)" }}>{children}</h2>;
  const H3 = ({ children }) => <h3 className="text-[16px] font-semibold mt-6" style={{ color: "var(--fg)" }}>{children}</h3>;
  const P = ({ children }) => <p>{children}</p>;
  const Ul = ({ children }) => <ul className="space-y-2 list-disc pl-5">{children}</ul>;
  const Li = ({ children }) => <li>{children}</li>;

  return (
    <PageLayout hero={hero}>
      <SectionReveal>
        <Content>
          <div>
            <H2>1. Veri Sorumlusu</H2>
            <P>Veri sorumlusu: <strong>Verasist Yazılım A.Ş.</strong> — Maslak Mah. AOS 55. Sokak No:2, Maslak 42 Ofis Kuleleri, Kat:12, 34398 Sarıyer / İstanbul. E-posta: kvkk@verasist.ai</P>
          </div>

          <div>
            <H2>2. Toplanan Kişisel Veriler</H2>
            <P>Platformumuz üzerinden aşağıdaki kişisel verileri topluyoruz:</P>
            <Ul>
              <Li><strong>Hesap bilgileri:</strong> Ad, soyad, e-posta, telefon, şirket adı, fatura adresi.</Li>
              <Li><strong>Görüşme verileri:</strong> Ses kayıtları, transkriptler, duygu analizi skorları, arama süreleri ve tarihleri.</Li>
              <Li><strong>Kullanım verileri:</strong> IP adresi, tarayıcı bilgisi, cihaz tipi, sayfa görüntüleme istatistikleri.</Li>
              <Li><strong>Ödeme bilgileri:</strong> Fatura tutarları, ödeme geçmişi (kredi kartı bilgileri ödeme sağlayıcımız tarafından işlenir, tarafımızca saklanmaz).</Li>
              <Li><strong>Entegrasyon verileri:</strong> Bağlı CRM, telefon santrali ve diğer üçüncü parti hesaplardan gelen yapılandırma verileri.</Li>
            </Ul>
          </div>

          <div>
            <H2>3. Veri Toplama Amaçları</H2>
            <P>Kişisel verileriniz şu amaçlarla işlenir:</P>
            <Ul>
              <Li>Hizmetlerimizin sağlanması ve iyileştirilmesi</Li>
              <Li>Faturalandırma ve muhasebe işlemleri</Li>
              <Li>Yasal yükümlülüklerin yerine getirilmesi</Li>
              <Li>Müşteri desteği ve teknik yardım</Li>
              <Li>Ürün geliştirme ve hata ayıklama</Li>
              <Li>Pazarlama iletişimleri (onay vermiş kullanıcılar için)</Li>
            </Ul>
          </div>

          <div>
            <H2>4. Veri Saklama Süresi</H2>
            <P>Kişisel veriler, yasal saklama süreleri ve hizmetin gerektirdiği süre boyunca saklanır:</P>
            <Ul>
              <Li><strong>Görüşme kayıtları ve transkriptler:</strong> Abonelik süresi + 90 gün (silme talebine bağlı olarak daha erken silinebilir).</Li>
              <Li><strong>Hesap bilgileri:</strong> Hesap aktif olduğu sürece + hesap silindikten sonra 2 yıl.</Li>
              <Li><strong>Fatura kayıtları:</strong> Türk vergi mevzuatı gereği 10 yıl.</Li>
            </Ul>
          </div>

          <div>
            <H2>5. Veri Güvenliği</H2>
            <P>Verileriniz, ISO 27001 uyumlu altyapımızda AES-256 şifreleme ile korunur. Tüm veriler Türkiye'deki veya seçtiğiniz AB bölgesindeki sunucularda saklanır. Aktarım sırasında TLS 1.3 kullanılır.</P>
          </div>

          <div>
            <H2>6. KVKK Kapsamındaki Haklarınız</H2>
            <P>KVKK'nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:</P>
            <Ul>
              <Li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</Li>
              <Li>İşlenmişse buna ilişkin bilgi talep etme</Li>
              <Li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</Li>
              <Li>Yurt içinde / yurt dışında aktarıldığı üçüncü kişileri bilme</Li>
              <Li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</Li>
              <Li>Silinmesini veya yok edilmesini isteme</Li>
              <Li>İşlemenin münhasıran otomatik sistemler vasıtasıyla analiz edilmesine itiraz etme</Li>
              <Li>Kanuna aykırı işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</Li>
            </Ul>
          </div>

          <div>
            <H2>7. İletişim</H2>
            <P>Gizlilik politikamız veya veri işleme ile ilgili sorularınız için: <a href="mailto:kvkk@verasist.ai" style={{ color: "var(--brand-cyan)" }}>kvkk@verasist.ai</a></P>
            <P className="mt-2 text-[13px]" style={{ opacity: 0.7 }}>Son güncelleme: 1 Temmuz 2026</P>
          </div>
        </Content>
      </SectionReveal>
    </PageLayout>
  );
};

export default PrivacyPage;
